import './tik_tok_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokPostContent extends Monitoring.Models.SocialContents.TikTokContent

  getRootParentId: ->
    return @get('id')

  rootPostId: ->
    return @get('id')

  rootAdExternalId: ->
    return null

  rootPostExternalId: ->
    return @externalId()

  isPost: ->
    return true

  isVideo: ->
    return @data().share_url?

  videoUrl: ->
    return @data().share_url

  videoThumbnailUrl: ->
    return @data().thumbnail_url

  showVideoAsLink: ->
    return true

  contentUrl: ->
    return @data().share_url
